import script from "./PageBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./PageBanner.vue?vue&type=script&setup=true&lang=js"

import "./PageBanner.vue?vue&type=style&index=0&id=7358d959&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7358d959"]])

export default __exports__